import { render, staticRenderFns } from "./holidays.vue?vue&type=template&id=939551c0&scoped=true&"
import script from "./holidays.vue?vue&type=script&lang=js&"
export * from "./holidays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939551c0",
  null
  
)

export default component.exports